/**
 * O botão do DaisyUI 4 que a loja usava, em utilitários (fase 2: saiu o CSS copiado do DaisyUI 4). Só o que não muda
 * de um uso para outro: cada uso soma tamanho, cor, borda, contorno, raio, fonte e sombra, porque no Tailwind 4 dois utilitários
 * da mesma propriedade no mesmo elemento não têm ordem garantida. Os usos (pagamento, PIX, pedidos, ajuda e o alerta de
 * produto adicionado) saem daqui quando cada fase de domínio passar para o `Button`.
 */
export const BTN_BASE =
    'inline-flex shrink-0 cursor-pointer select-none flex-wrap items-center justify-center gap-2 text-center no-underline transition-[color,background-color,border-color,opacity,box-shadow,transform] duration-200 ease-[cubic-bezier(0,0,0.2,1)] focus-visible:outline-2 focus-visible:outline-offset-2 active:hover:scale-95 active:focus:scale-95 motion-safe:animate-button-pop'

/** Sombra do botão do DaisyUI 4 (a do botão fantasma não tem). */
export const BTN_SHADOW = 'shadow-[0_1px_2px_0_rgba(0,0,0,0.05)]'

/** Borda escurecida no hover, como no DaisyUI 4 (90% da cor do botão com preto). */
export const BTN_HOVER_BORDER_BASE = 'hover:border-[color-mix(in_oklab,var(--color-base-200)_90%,#000)]'
export const BTN_HOVER_BORDER_SUCCESS = 'hover:border-[color-mix(in_oklab,var(--color-success)_90%,#000)]'

/** Botão desabilitado do DaisyUI 4. */
export const BTN_DISABLED =
    'disabled:pointer-events-none disabled:border-transparent disabled:bg-neutral/20 disabled:text-base-content/20'
